module.exports = __webpack_public_path__ + "static/btn_act.d83d3dea.png";